import type { Timestamp } from 'firebase/firestore';

/** Notification type. Extensible for future: feedback_comment_reply, like, connection_request, etc. */
export type NotificationType = 'feedback_comment';

export interface Notification {
  id: string;
  recipientUserId: string;
  actorUserId: string;
  actorDisplayName: string;
  actorUsername: string;
  actorPhotoURL: string | null;
  type: NotificationType;
  postId: string;
  commentId: string;
  postTitle: string;
  previewText: string;
  read: boolean;
  readAt: Timestamp | null;
  createdAt: Timestamp | null;
  updatedAt: Timestamp | null;
  metadata?: Record<string, unknown>;
}

export const USERS_COLLECTION = 'users';
export const NOTIFICATIONS_SUBCOLLECTION = 'notifications';

// Kept for backward compatibility in case older code still references it.
export const NOTIFICATIONS_COLLECTION = 'notifications';
